    <div class="box1">
        <div class="header">
            <div class="title-container">
                <span class="title">Opstellen Bericht</span>
            </div>
        </div>

        <mat-divider></mat-divider>
        <br>

        <mat-dialog-content class="no-scroll">
            <form [formGroup]="SendMailFormGroup">
                <mg-simple-form-row>
                    <span mg-colspan-2>
                        <mat-form-field pd-size-max>
                            <input type="text" placeholder="Onderwerp" matInput formControlName="Subject">
                        </mat-form-field>
                    </span>
                </mg-simple-form-row>
                <br>
                <mg-simple-form-row>
                    <span class="wysiwygWrapper">
                        <quill-editor #editor [sanitize]="true" [modules]="editorOptions" placeholder="Bericht" matInput formControlName="Message"></quill-editor>
                    </span>
                </mg-simple-form-row>

            </form>
        </mat-dialog-content>

        <mat-dialog-actions>
            <div class="button-container">
                <button mat-stroked-button class="button-margin" id="cancelbutton" color="warn" (click)="Cancel()">Annuleren</button>
                <button mat-stroked-button id="savebutton" mat-button color="primary" (click)="Ok()" [disabled]="this.dialogData.users.length == 0 && this.dialogData.relaties.length == 0">Versturen</button>
            </div>
        </mat-dialog-actions>

    </div>
    <div class="box2">
        <div class="recipients">
            <div class="content-item">
                <mat-icon color="primary">people</mat-icon>
                <span class="undertitle">Aan :</span>
            </div>
            <mat-divider></mat-divider>
            <i *ngIf="this.dialogData.users.length == 0 && this.dialogData.relaties.length == 0">Er zijn geen ontvangers gekoppeld!</i>

            <mat-chip-list *ngIf="this.dialogData.users.length > 0">
                <mat-chip class="recipient-chip" color="primary" [selectable]="false" title="{{user.email}}" *ngFor="let user of this.dialogData.users; let i = index" (click)="removeUser(i)">
                    {{ user.firstName }} {{ user.lastName }}
                    <mat-icon class="close-icon">close</mat-icon>
                </mat-chip>
            </mat-chip-list>

            <mat-chip-list *ngIf="this.dialogData.relaties.length > 0">
                <mat-chip class="recipient-chip" color="primary" [selectable]="false" title="{{relatie.eMail}}" *ngFor="let relatie of this.dialogData.relaties; let i = index" (click)="removeRelatie(i)">
                    {{ relatie.naam1 }}
                    <mat-icon class="close-icon">close</mat-icon>
                </mat-chip>
            </mat-chip-list>

        </div>
    </div>
